import * as React from 'react';
import { Container, Heading } from '@grandvisionhq/elements';
import { ProductBannerView } from '@grandvisionhq/products';

const AlgoliaCrossSellProducts = ({ title , result , isLoading , handleImpression , handleInteraction ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-products",
        "data-t": "cross-sell-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium"
    }, title), /*#__PURE__*/ React.createElement(ProductBannerView, {
        products: result,
        isLoading: isLoading,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction,
        productLocation: "crossSell"
    })));
};

export { AlgoliaCrossSellProducts, AlgoliaCrossSellProducts as default };
//# sourceMappingURL=AlgoliaCrossSellProducts.js.map
